module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4x99D"))).then(() => parcelRequire('hEqeo'));